import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import type { ObjectGraphConfigurationLocalStorage } from '../types.tsx';

const OBJECT_GRAPH_CONFIGURATION_KEY = 'objectGraphConfiguration';
export const storage = createLocalStorageProvider('jsm-cmdb-object-graph');

export const getGraphConfigurationLocalStorage = ():
	| ObjectGraphConfigurationLocalStorage
	| undefined => {
	try {
		const graphConfig = storage.get(OBJECT_GRAPH_CONFIGURATION_KEY);
		if (graphConfig) {
			const { referenceDepth, maxOfSameType } = JSON.parse(graphConfig);
			return { referenceDepth, maxOfSameType };
		}
		return undefined;
	} catch (err) {
		return undefined;
	}
};

export const setGraphConfigurationLocalStorage = (
	updatedConfig: ObjectGraphConfigurationLocalStorage,
): void => {
	const existingConfig = getGraphConfigurationLocalStorage();
	storage.set(
		OBJECT_GRAPH_CONFIGURATION_KEY,
		JSON.stringify({ ...existingConfig, ...updatedConfig }),
	);
};

export const getReferenceCheckedLocalStorage = ({
	objectTypeId,
	referenceLabel,
}: {
	objectTypeId: string;
	referenceLabel: string;
}): boolean | undefined => {
	try {
		const isChecked = storage.get(`objectType${objectTypeId}-reference${referenceLabel}`);
		return JSON.parse(isChecked);
	} catch (error) {
		return undefined;
	}
};

export const setReferenceCheckedLocalStorage = ({
	objectTypeId,
	referenceLabel,
	updatedValue,
}: {
	objectTypeId: string;
	referenceLabel: string;
	updatedValue: boolean;
}): void => {
	storage.set(`objectType${objectTypeId}-reference${referenceLabel}`, JSON.stringify(updatedValue));
};
